import React, { useLayoutEffect, useRef, useState } from "react";
import { GoogleLogin } from "@react-oauth/google";

function GoogleMark() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.53 5.53 0 0 1-2.4 3.63v3.01h3.88c2.27-2.09 3.54-5.17 3.54-8.88z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.88-3.01c-1.08.72-2.45 1.16-4.05 1.16-3.12 0-5.76-2.11-6.7-4.94H1.29v3.09A12 12 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.3 14.3A7.2 7.2 0 0 1 4.92 12c0-.8.14-1.57.38-2.3V6.61H1.29A12 12 0 0 0 0 12c0 1.94.46 3.77 1.29 5.39l4.01-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.76 0 3.34.61 4.58 1.8l3.44-3.44C17.94 1.14 15.24 0 12 0 7.31 0 3.26 2.69 1.29 6.61l4.01 3.09C6.24 6.86 8.88 4.75 12 4.75z" />
    </svg>
  );
}

export default function GoogleContinueButton({ onSuccess, onError, disabled = false }) {
  const shellRef = useRef(null);
  const [width, setWidth] = useState(320);

  useLayoutEffect(() => {
    const el = shellRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const measure = () => {
      const w = Math.floor(el.getBoundingClientRect().width);
      if (w > 0) setWidth(Math.max(240, Math.min(400, w)));
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div
      className={`google-continue${disabled ? " is-disabled" : ""}`}
      ref={shellRef}
    >
      <div className="google-continue-gis">
        <GoogleLogin
          onSuccess={onSuccess}
          onError={onError}
          width={width}
          size="large"
          text="continue_with"
          shape="rectangular"
          theme="filled_black"
          logo_alignment="left"
        />
      </div>
      <button
        type="button"
        className="oauth-provider-btn google-continue-face"
        tabIndex={-1}
        disabled={disabled}
      >
        <span className="oauth-provider-icon" aria-hidden="true">
          <GoogleMark />
        </span>
        <span className="oauth-provider-label">Continue with Google</span>
      </button>
    </div>
  );
}
